import * as Blockly from 'blockly/core';
import { stmts } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['monitor_graph'] = function (block: Blockly.Block): string {
        const ids: string[] = (block as any)._ids ?? [];
        const liveIds =
            ids.length > 0
                ? ids
                : block.inputList.filter((i) => i.name.startsWith('VAL_')).map((i) => i.name.replace('VAL_', ''));

        const lines: string[] = [];

        liveIds.forEach((id, index) => {
            const label = gen.valueToCode(block, `LABEL_${id}`, 0) || '""';
            const val = gen.valueToCode(block, `VAL_${id}`, 0) || '0';

            lines.push(`Serial.print(${label})`);
            lines.push(`Serial.print(":")`);
            lines.push(`Serial.print(${val})`);

            if (index < liveIds.length - 1) {
                lines.push(`Serial.print(",")`);
            }
        });

        lines.push(`Serial.println()`);

        return stmts(lines);
    };
}
